import React from "react";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { useNavigate } from "react-router-dom";



const Calender = () => {
    const navigate = useNavigate();
    const AUTH_TOKEN = process.env.REACT_APP_CALENDLY_AUTH_TOKEN;

    const handleEventScheduled = async (eventData) => {
        // Extract the URI from the eventData payload
        const eventUri = eventData.data.payload.event.uri;

        console.log('Event URI:', eventUri);

        try {
            // Fetch event details using the URI
            const response = await fetch(eventUri, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${AUTH_TOKEN}`,
                },
            });


            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            // Parse the response to get event details
            const eventDetails = await response.json();

            console.log('Full Event Details:', eventDetails);
            navigate("/congrats")

            // Handle the full event details (e.g., forward to another API, etc.)
        } catch (error) {
            console.error('Error fetching event details:', error);
        }
    }

    useCalendlyEventListener({
        // onProfilePageViewed: () => console.log("onProfilePageViewed"),
        // onDateAndTimeSelected: () => console.log("onDateAndTimeSelected"),
        // onEventTypeViewed: () => console.log("onEventTypeViewed"),
        onEventScheduled: (eventData) => { handleEventScheduled(eventData) },
        // onPageHeightResize: (e) => console.log(e.data.payload.height),
    });

    return (
        <div className="App">
            <InlineWidget url="https://calendly.com/website-khamkar"
            />
        </div>
    );
};

export default Calender;